import { Button, ModalInfo, useModalState } from '@bpba/ui-components';
import { useState } from 'react';
import { Establecimiento } from '../../rest/models/Establecimiento';
import Table from './Tabla';
import { TbCirclePlus } from 'react-icons/tb';
import { VscDash } from 'react-icons/vsc';
import { TIPO_PACTAR } from '../../Constantes';
import InformacionAdicional from './InformacionAdicional';

export const GrillaDesktop = ({ establecimientos, tipo, muestraLocalidad }: { establecimientos: Establecimiento[]; tipo: string; muestraLocalidad: boolean;}) => {

  const [informacionAdicional, setInformacionAdicional] = useState<Establecimiento>();
  const [isOpen, open, close] = useModalState();
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const sortedData = [...establecimientos].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];
    if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });
  const requestSort = (key: any) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
  const showInformacionAdicional = (value: Establecimiento) => () => {
    setInformacionAdicional(value);
    open();
  };
  return (
    <>
      <Table tabIndex={0} fontSize={0} style={{ overflow: 'auto' }}>
        <caption hidden>Lista de comercios adheridos</caption>
        <Table.THeader bg="secondary.1" color="white">
          <Table.Tr>
            <Table.Th id="denominacion" width="20%" onClick={() => requestSort('denominacion')}>
              Denominación{sortConfig.key === 'denominacion' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </Table.Th>
            <Table.Th id="rubros" width="15%" onClick={() => requestSort('rubro')}>
              Rubro{sortConfig.key === 'rubro' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </Table.Th>
            {muestraLocalidad && (
              <Table.Th id="localidades" width="20%" onClick={() => requestSort('localidad')}>
                Localidad{sortConfig.key === 'localidad' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </Table.Th>
            )}
            {tipo === TIPO_PACTAR && (<><Table.Th id="regiones" width="20%" onClick={() => requestSort('region')}>
              Region{sortConfig.key === 'region' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </Table.Th>
              <Table.Th id="infoextra" width="20%">
                Información
              </Table.Th></>)}
          </Table.Tr>
        </Table.THeader>
        <Table.TBody>
          {sortedData?.map((value, index) => {
            return (
              <Table.Tr key={index}>
                <Table.Td headers={'denominacion'}>{value.denominacion}</Table.Td>
                <Table.Td headers={'rubros'}>{value.rubro}</Table.Td>
                {muestraLocalidad && (<Table.Td headers={'localidades'}>{value.localidad}</Table.Td>)}{tipo === TIPO_PACTAR && (<>
                  <Table.Td headers={'regiones'}>
                    {value.region}
                  </Table.Td>
                  <Table.Td headers={'informacion adicional'}>
                    {value.email && (
                      <Button
                        variant="icon" onClick={showInformacionAdicional(value)} aria-label="Detalle de la empresa">
                        <TbCirclePlus size="24" />
                      </Button>
                    )}
                  </Table.Td>
                </>
                )}
              </Table.Tr>
            );
          })}
          {establecimientos?.length === 0 && (
            <Table.Tr>
              <Table.Td textAlign="left" headers={'denominacion'} colSpan={5}>
                No se encontraron resultados
              </Table.Td>
            </Table.Tr>
          )}
        </Table.TBody>
      </Table>
      <ModalInfo title="Información adicional" show={isOpen} onClose={close}>
        <InformacionAdicional informacionAdicional={informacionAdicional} />
      </ModalInfo>
    </>
  );
};
